import htmx, { HtmxResponseInfo } from 'htmx.org';
import 'boxicons'
import 'bootstrap'

const clearFunc = function (event: Event) {
  const elem = (event as CustomEvent<HtmxResponseInfo>).detail.requestConfig.triggeringEvent.target as HTMLElement;
  const successAttr = elem.attributes.getNamedItem('hx-success-indicator')?.value;
  const errorAttr = elem.attributes.getNamedItem('hx-error-indicator')?.value;
  if (successAttr || errorAttr) {
    const successTargets = successAttr ? Array.from(document.querySelectorAll(successAttr) as NodeListOf<HTMLElement>) : [];
    const errorTargets = errorAttr ? Array.from(document.querySelectorAll(errorAttr) as NodeListOf<HTMLElement>) : [];
    for (const target of [...successTargets, ...errorTargets]) {
      if (target) {
        target.style.display = 'none';
      } else {
        console.warn('Missing target for ' + [successAttr, errorAttr]);
      }
    }
  }

  for (const element of Array.from(document.querySelectorAll('.field-validation-error') as NodeListOf<HTMLElement>)) {
    element.style.display = 'none';
  }
}

let errorFuncTimeout: number;
const errorFunc = function (event: Event) {
  const elem = (event as CustomEvent<HtmxResponseInfo>).detail.requestConfig.triggeringEvent.target as HTMLElement;
  const attr = elem.attributes.getNamedItem('hx-error-indicator')?.value;
  if (attr) {
    const targets = document.querySelectorAll(attr) as NodeListOf<HTMLElement>;
    for (const target of Array.from(targets)) {
      if (target) {
        target.style.display = target.dataset.display ?? 'block';
        if (target.dataset.timeout) {
          clearTimeout(errorFuncTimeout);
          errorFuncTimeout = setTimeout(() => {
            target.style.display = 'none';
          }, target.dataset.timeout as unknown as number);
        }
      } else {
        console.warn('Missing target for ' + attr);
      }
    }
  }
}

let successFuncTimeout: number;
const successFunc = function (event: Event) {
  const elem = (event as CustomEvent<HtmxResponseInfo>).detail.requestConfig.triggeringEvent.target as HTMLElement;
  const attr = elem.attributes.getNamedItem('hx-success-indicator')?.value;
  if (attr) {
    const targets = document.querySelectorAll(attr) as NodeListOf<HTMLElement>;
    for (const target of Array.from(targets)) {
      if (target) {
        target.style.display = target.dataset.display ?? 'block';
        if (target.dataset.timeout) {
          clearTimeout(successFuncTimeout);
          successFuncTimeout = setTimeout(() => {
            target.style.display = 'none';
          }, target.dataset.timeout as unknown as number);
        }
      } else {
        console.warn('Missing target for ' + attr);
      }
    }
  }
}

htmx.on('htmx:timeout', errorFunc);
htmx.on('htmx:beforeRequest', clearFunc);
htmx.on('htmx:afterRequest', function (event: Event) {
  if ((event as CustomEvent<HtmxResponseInfo>).detail.successful) successFunc(event)
  else if ((event as CustomEvent<HtmxResponseInfo>).detail.failed) errorFunc(event);
})

htmx.on('htmx:configRequest', function (event: Event) {
  const form = (event.target as HTMLElement).closest('form');
  if (form && !form.checkValidity()) {
    event.preventDefault();
    form.classList.add('was-validated');
  }
});

htmx.on('htmx:confirm', (event: Event) => {
  const htmxEvent = event as CustomEvent;

  if (htmxEvent.detail.question == null || htmxEvent.detail.question == "") {
    return;
  }

  const dialogString = generateDeleteDialog(htmxEvent.detail.question);
  document.body.insertAdjacentHTML('beforeend', dialogString);

  const dialog = document.body.querySelector<HTMLDialogElement>('.htmx-confirm');
  if (dialog == null) {
    return;
  }

  htmxEvent.preventDefault();

  dialog.addEventListener('close', () => {
    if (dialog.returnValue === "ok") {
      htmxEvent.detail.issueRequest(true);
    }

    dialog.remove();
  });

  dialog.showModal();

  return;
});

const generateDeleteDialog = (text: string) => `
<dialog class="htmx-confirm border rounded">
    <form class="mb-0" method="dialog">
    <div class="mb-3">
        ${text}
    </div>
    <div class="d-flex justify-content-between">
        <button type="submit" class="btn btn-primary" value="ok">Ok</button>
        <button type="submit" class="btn btn-secondary" value="">Cancel</button>
    </div>
    </form>
</dialog>

`

